import React, { memo, useCallback, useMemo } from 'react'

import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { TrashIcon } from '../../../../UI/Icons/Icons'

import Input from '../../../../UI/Input/Input'
import Checkbox from '../../../../UI/CheckBox/CheckBox'

import { setAllSelected, setAllUnselected } from '../../../../redux/actions/chat.action'

export const Header = memo(({ dialogs, search, setSearch, onDelete }) => {
  const dispatch = useDispatch()

  const isAllSelected = useMemo(() => dialogs.list.every((item) => item.is_selected), [dialogs.list])
  const isSomeSelected = useMemo(() => dialogs.list.some((item) => item.is_selected), [dialogs.list])

  const handleAllClick = useCallback(() => {
    if (isAllSelected) {
      dispatch(setAllUnselected())
    } else {
      dispatch(setAllSelected())
    }

    // eslint-disable-next-line
  }, [isAllSelected])

  return (
    <>
      <div className={styles.header}>
        <Input value={search} onChange={({ target }) => setSearch(target.value)} type="text" placeholder="Search" />
      </div>

      <div className={styles.controls}>
        {isSomeSelected && (
          <>
            <Checkbox id="all" theme="bordered" checked={isAllSelected} onChange={handleAllClick}>
              Select all
            </Checkbox>

            <button onClick={onDelete} className={styles.delete}>
              <TrashIcon height={13} width={11} strokeColor="var(--color-white)" />

              <span>Delete</span>
            </button>
          </>
        )}

        {!isSomeSelected && `All chats ${dialogs.list.length}`}
      </div>
    </>
  )
})
